import gql from 'graphql-tag';

/**
 * Students fill in their own profile data: the fields the school opened to
 * them, and the settings for which built-in fields they may fill in.
 */
export const STUDENT_PROFILE_FORM_FIELDS = gql`
  fragment StudentProfileFormFields on StudentProfileForm {
    missing_required
    fields {
      key field_id label type is_required max_length editable requested locked value filled_by filled_at description
      options { value label }
      options_source depends_on
    }
  }
`;

export const GET_MY_STUDENT_PROFILE_FORM = gql`
  query MyStudentProfileForm {
    myStudentProfileForm { ...StudentProfileFormFields }
  }
  ${STUDENT_PROFILE_FORM_FIELDS}
`;

export const UPDATE_MY_STUDENT_PROFILE_FORM = gql`
  mutation UpdateMyStudentProfileForm($values: [StudentProfileValueInput!]!) {
    updateMyStudentProfileForm(values: $values) { ...StudentProfileFormFields }
  }
  ${STUDENT_PROFILE_FORM_FIELDS}
`;

export const GET_STUDENT_PROFILE_FIELD_SETTINGS = gql`
  query StudentProfileFieldSettings {
    studentProfileFieldSettings { key label type access values_count }
  }
`;

export const UPDATE_STUDENT_PROFILE_FIELD_SETTINGS = gql`
  mutation UpdateStudentProfileFieldSettings($fields: [StudentProfileFieldSettingInput!]!) {
    updateStudentProfileFieldSettings(fields: $fields) { key label type access values_count }
  }
`;
